import React, { useEffect, useState, useRef } from "react";
import bgImage from "../../pages/culture/cultureImage/banner-bg.209b7822a63dca486753.svg";
import Software from "../culture/cultureImage/7-years.jpg";
import Celebrating from "./celebrating";
import AOS from "aos";
import "aos/dist/aos.css";
import AboutImage from "../../../assests/cultureNew.png";
import { Helmet } from "react-helmet-async";

const Journey = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [bgPositionY, setBgPositionY] = useState(5.69531);
  const [bgPositionYx, setBgPositionYx] = useState(2.45);

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // whether animation should happen only once
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const { isIntersecting, boundingClientRect } = entry;
        const isEnteringFromBottom =
          isIntersecting && boundingClientRect.top > 0;

        setIsVisible(isEnteringFromBottom);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Scroll event to adjust background position
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newPositionY = 5.69531 - scrollY * 0.5; // Adjust the multiplier as needed
      const newPositionYx = 2.69531 - scrollY * 0.3; // Adjust the multiplier as needed
      setBgPositionY(newPositionY);
      setBgPositionYx(newPositionYx);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <> <Helmet>
      <link rel="canonical" href="https://www.tekitsolution.com/culture" />
        </Helmet>
    <div className="z-10 ">
      <section
        ref={sectionRef}
        className={`relative w-full lg:h-[450px] h-full bg-fixed bg-center bg-cover  `}
        style={{
          backgroundImage: `url(${AboutImage})`,
        }}
      ></section>
      <div className=" lg:w-full w-[90%] mx-auto  py-16 lg:py-2 bg-white font-recoleta">
        <div className="lg:px-14">
          <h1
            className="text-[#F86F4B] 2xl:text-[38px] lg:text-[28px] text-[54px] font-bold px-14 text-center mt-12"
            data-aos="fade-up"
          >
            {" "}
            7th Foundation Day – February 13, 2025

          </h1>
          <div className="lg:flex mt-12 ">
            <div className="lg:w-[45%] w-full">
              <div className="relative w-full   overflow-hidden">
                {/* Rotating Circle with Circular Motion */}
                {/* <div className="absolute w-72 h-72 border-2 border-gray-200 rounded-full animate-circular-motion top-30 left-20"></div> */}
                {/* <div className="absolute w-72 h-72 border-2 border-gray-200 rounded-full animate-circular-motion top-25 left-10"></div> */}
                {/* Image */}
                <img
                  src={Software}
                  data-aos="fade-right"
                  alt=" Celebration"
                  className="relative z-1 w-full h-full object-cover p-2 rounded-lg"
                />
              </div>

              {/* <img src={Software} className='p-4 w-full' />  */}
            </div>
            <div className="lg:w-[55%] w-full content-center p-4 font-recoleta">
              <p
                data-aos="fade-left"
                className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4"
              >
                A remarkable journey of innovation and impact.

              </p>


              <div data-aos="fade-left" className="mt-4">
                <p className="2xl:text-[28px] lg:text-[18px] text-[28px] font-semibold">
                Highlights of the day:
                </p>
                <ul className="list-disc ml-7 mt-2 space-y-1 text-[28px] lg:text-[18px] 2xl:text-[28px]">
                  <li>New Logo Reveal</li>
                  <li>Website Relaunch</li>
                  <li>Cake Cutting & Office Party</li>
                  <li>Heartfelt moments, laughter, and team camaraderie

</li>
                </ul>
              </div>
              <p
                data-aos="fade-left"
                className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4"
              >
                Cheers to 7 years of building, thriving, and dreaming big — together.


              </p>
              
            </div>
          </div>
        </div>
        <Celebrating />
      </div>
    </div>
    </>
  );
};

export default Journey;
